<script lang="ts">
	import { page } from '$app/stores';
	import { ContentBlocksWrapper } from '@atoms';
	import Head from '@atoms/Head.svelte';
</script>

<Head tags={[{ tag: 'title', content: 'UPS! - Musikhuset Aarhus' }]} />

<ContentBlocksWrapper>
	<section>
		{#if $page.status === 404}
			<h1 class="text:h3">
				Vi har virkelig forsøgt at lede. Desværre kan vi ikke finde den side, du søger.
			</h1>
			<p class="text:body-lg">
				Men bare rolig. Vi har masser af inspiration til fede liveoplevelser. <br /> Prøv for eksempel
				vores:
			</p>
			<!-- {:else if $page.status === 500} -->
		{:else}
			<h1 class="text:h3">UPS! Det her er lidt pinligt. Denne side er i stykker.</h1>
			<p class="text:body-lg">
				Hav venligst lidt tålmodighed med os. Vi gør vores bedste for at få siden til at spille
				igen.
			</p>
			{#if $page.error?.errorId}
				<p class="text:body">Fejl-ID: {$page.error.errorId}</p>
			{/if}
		{/if}
		<a class="button:pill" href="/">Forside</a>
		<a class="button:pill" href="/kalender">Kalender</a>
	</section>
</ContentBlocksWrapper>

<style lang="scss">
	section {
		display: flex;
		text-align: left;
		flex-direction: column;
		align-items: left;
		gap: 1em;
		padding-bottom: var(--spacing-auto);
		@include largeBlock;

		@include md {
			gap: 1.5em;
		}

		a {
			width: 200px;
		}
	}
</style>
